import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';

const Login = () => {
  return (
    <>
      <h5>
        <b>Login/SignUp</b>
      </h5>
      <p>
        The login sign up plugin allows you to integrate role-based access into your no code web
        application so that users can access your app through login credentials.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/login-sign-up-plugin/" />
    </>
  );
};

export default Login;
